<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { Icon } from '@iconify/vue'
import Logo from '@/assets/logo.svg'

const route = useRoute()
const router = useRouter()
const { t } = useI18n()

const tabs = [
  {
    i18nKey: 'component.tabbar.home',
    type: 'route',
    path: '/home',
    active: 'solar:fire-bold',
    inactive: 'solar:fire-bold-duotone',
  },
  {
    i18nKey: 'component.tabbar.recommend',
    type: 'route',
    path: '/theater',
    active: 'solar:video-library-bold-duotone',
    inactive: 'solar:video-library-line-duotone',
  },
  {
    i18nKey: 'component.tabbar.creation',
    type: 'route',
    path: '/creation',
    active: 'solar:add-square-bold',
    inactive: 'solar:add-square-broken',
  },
  {
    i18nKey: 'component.tabbar.live',
    type: 'external',
    url: 'https://www.acadsoc.com.cn/lps/duanxin/2026/02/26.html',
    active: 'solar:play-stream-bold',
    inactive: 'solar:play-stream-bold-duotone',
  },

  {
    i18nKey: 'component.tabbar.profile',
    type: 'route',
    path: '/profile',
    active: 'solar:user-bold-duotone',
    inactive: 'solar:user-broken',
  },
]
const isActive = (path: string) => route.path === path

const handleTabClick = (tab: { type: string; path?: string; url?: string }) => {
  if (tab.type === 'route' && tab.path) {
    router.push(tab.path)
  } else if (tab.type === 'external' && tab.url) {
    window.open(tab.url, '_blank')
  }
}
</script>

<template>
  <aside
    class="sticky top-0 flex h-screen w-56 flex-col bg-[linear-gradient(130deg,rgba(147,51,234,0.4)_0%,rgba(147,51,234,0.08)_18%,rgb(3,7,18)_30%,rgb(3,7,18)_100%)] px-3 py-4"
  >
    <div class="mb-6 px-2 text-xl font-semibold tracking-wide text-white">
      <img :src="Logo" alt="Logo" class="inline-block size-8 mr-2 -mt-1" />
      {{ t('login.page.title') }}
    </div>
    <div class="flex-1 flex flex-col justify-between">
      <nav class="space-y-1 flex-1 flex flex-col">
        <button
          v-for="tab in tabs"
          :key="tab.type === 'route' ? tab.path : tab.url"
          class="flex w-full items-center gap-3 rounded-xl px-3 py-2 text-left text-lg transition-colors duration-200"
          :class="isActive(tab.path ? tab.path : '') ? 'bg-white/20 text-white' : 'text-gray-300 hover:bg-white/10'"
          @click="handleTabClick(tab)"
        >
          <Icon class="text-2xl" :icon="isActive(tab.path ? tab.path : '') ? tab.active : tab.inactive" />
          <span class="text-base font-medium">{{ t(tab.i18nKey) }}</span>
        </button>
      </nav>
    </div>
  </aside>
</template>
